var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"block-spacer",class:'spacer-' + _vm.type,attrs:{"src":_vm.sourceImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }